import "../../node_modules/@glidejs/glide/dist/css/glide.core.min.css";
import Glide from "@glidejs/glide";
const slider = document.querySelector(".glide-zee");
const amount = document.querySelector("[data-role='slide-zee-amount']");

if (slider && amount) {
  const totalSlideCount = amount.getAttribute("data-count");
  const glide = new Glide(".glide-zee", {
    perView: 1.2,
  });

  glide.on(["mount.after", "run"], function () {
    const index = glide.index + 1;
    amount.innerHTML = `${index.toString()} / ${totalSlideCount}`;
  });

  glide.mount();
}
